import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { MessageWrapper, RED } from '../Styles';
// FIXME: WHEN LOG IS DELETED FROM ONE SCREEN, MAKE SURE OTHER SCREENS SHOW THAT IT'S DELETED TOO.
export const DeleteLogButton = observer(() => {
  const {
    DebuggerStore: { deleteLog, logCount },
  } = useStores();
  
  if (logCount === 0) return null;

  return (
    <MessageWrapper
      bgColor={RED}
      onClick={deleteLog}
      style={{ cursor: 'pointer' }}
      title="CLICK TO DELETE THE CURRENT SIMULCAST LOG FROM LOCAL STORAGE AND RESTART THE LOGGING -- ALL PREVIOUS DATA WILL BE DELETED."
    >
      Delete Log
    </MessageWrapper>
  );
});

export default DeleteLogButton;
